import React from "react";

const WebsiteHeading = (props) => {
  const decodedHost = decodeURIComponent(atob(props.match.params.host));

  return (
    <div className="mt-4">
      <span className="graphikFont" style={{ color: "rgba(26, 26, 26, 0.45)" }}>
        {decodedHost}
      </span>
    </div>
  );
};

export default WebsiteHeading;
